<script setup>
    const apiDomain = process.env.VUE_APP_API_URL.replace('/api_v2', '')
    const dataSet = document.createElement('div')
    dataSet.setAttribute('id', 'internal-chat-api')
    dataSet.setAttribute('data-domain', apiDomain)
    document.body.appendChild(dataSet)
    const script = document.createElement('script')
    script.setAttribute('id', 'internal-chat')
    script.setAttribute('onload', `init('${process.env.VUE_APP_WEB_CHAT_API_KEY}')`)
    script.setAttribute('src', window.origin + '/webChatFull.js')
    script.defer = true
    script.async = true
    document.body.appendChild(script)
</script>

<template>
    <h1>Hello world :)</h1>
</template>
